import { useLocation } from "react-router-dom";
import { routes } from "~/constants";
import { usePartner } from "~/OnboardingApp/hooks";
import { MetaByPath, metaByPath, partnerMetaByPath } from "../config";
import { buildPartnerMetaByPath } from "../utils";

const metaByPathConfig = {
  onboarding: {
    config: metaByPath,
    completedNextPath: routes.planSelect,
  },
  partner: {
    config: partnerMetaByPath,
    completedNextPath: routes.partnerActivate,
  },
};

interface UseMetaByPathConfig {
  metaByPath: MetaByPath;
  questionnaireOrder: string[];
  progressBarTotal: number;
  completedNextPath: string;
}

export const useMetaByPathConfig = (): UseMetaByPathConfig => {
  const { pathname } = useLocation();
  const metaConfig = useRouteMatch(pathname);

  return metaConfig;
};

const useRouteMatch = (pathname: string) => {
  const { partnerSlugify } = usePartner();
  const metaByPath = buildMetaByPath(pathname);
  const questionnaireOrder = buildQuestionnaireOrder(metaByPath);
  const progressBarTotal = buildProgressBarTotal(metaByPath);
  const completedNextPath = partnerSlugify(getCompletedNextPath(pathname));

  return {
    metaByPath,
    questionnaireOrder,
    progressBarTotal,
    completedNextPath,
  };
};

const getConfigType = (pathname: string) => {
  const first = (pathname.split("/")[1] || "onboarding") as
    | "onboarding"
    | "partner";

  return first;
};

const getCompletedNextPath = (pathname: string) => {
  const configType = getConfigType(pathname);
  const completedNextPath = metaByPathConfig[configType].completedNextPath;

  return completedNextPath;
};

const buildMetaByPath = (pathname: string) => {
  const configType = getConfigType(pathname);
  const config = metaByPathConfig[configType].config;

  if (configType == "onboarding") {
    return config;
  } else {
    const partnerPatternMetaByPath = config;
    const newMetaByPath = buildPartnerMetaByPath(
      pathname,
      partnerPatternMetaByPath,
    );

    return newMetaByPath;
  }
};

const buildQuestionnaireOrder = (metaByPath: MetaByPath) => {
  const questionnaireOrder = Object.keys(metaByPath);

  return questionnaireOrder;
};

const buildProgressBarTotal = (metaByPath: MetaByPath) => {
  return Object.values(metaByPath).filter(
    ({ excludeFromProgress }) => !excludeFromProgress,
  ).length;
};
